<template>
  <div class="view" id="photoUpload">
    <!--<div v-on:click="redo" class='back-but'></div>-->
    <div class='inside-closer' v-on:click="close">✖</div>
    <div class="slide-container" v-if="user === null">
      <div class='padding-80'></div>
      <img src='./../assets/profile_off.svg' width="50"><br><br>
      Du måste vara inloggad för att bidra!
      <div class='padding-40'></div>
      <router-link to="/profile" class="black-on-white-butt">Logga in eller skapa ett konto</router-link>
    </div>
    <div class="slide-container" v-if="user !== null">
      <div v-show="view === 'register'">
        Registrera dig för att ladda upp.
      </div>
      <div v-show="view === 'addemail'">
        Registrera dig för att ladda upp.
      </div>
      <div v-show="view === 'upload'" class="slide-view">
        <div class='padding-40'></div>
        <div class="upload-icon"></div>

        <div v-if="userOS === 'ios'" v-on:click='openInIos' class='black-on-white-butt margin-40'>1. Fota med Lightroom</div>
        <a v-if="userOS === 'android'" href='https://play.google.com/store/apps/details?id=com.adobe.lrmobile' target="_blank" class='black-on-white-butt margin-40' v-on:click="openInGoogle">1. Fota med Lightroom</a>
        <a v-if="userOS === false" href='https://lightroom.adobe.com/' target="_blank" class='black-on-white-butt margin-40'>1. Fota med Lightroom</a>
        <label class='upload-file-label'>
          <input type="file" id="fileupload-input" name="fileupload" @change="selectFile" accept="image/*" class="input-file">
          <span v-if="isSaving"><div class='body-heading margin-20'><br>Hämtar...</div></span>
          <span v-else><div class='blue-butt margin-20'>2. Ladda upp foto</div></span>
        </label>
        <div class='padding-40'></div>
        <div class="body-white">
          <div class='body-heading'>Tips: {{tip.title}}</div>
          <div v-html="tip.body"></div>
        </div>
        <div class='padding-40'></div>
        <div class='padding-80'></div>
      </div>
      <div v-show="view === 'confirm'" class='confirm-upload'>
        <canvas id='thumb-canvas'></canvas>
        <div id="preview-image"></div>
        <div class="body-white padding-40">
          <!--<div class='body-heading'></div>-->
          Användare i spelet bestämmer hur bra fotot är. I röstningen väljer man om man tycker ett foto är bra eller mindre bra.
        </div>
        <div v-if="uploading === false">
          <div class='blue-butt margin-40' v-on:click="uploadImage">Skicka in foto</div>
          <div class='padding-80'></div>
        </div>
        <div v-if="uploading === true">
          <div class='body-heading padding-40'>Laddar upp...{{uploadingPhotoProgress}}%</div>
        </div>
        <div class='padding-80'></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'photoUpload',
  data () {
    return {
      view: 'upload',
      isSaving: false,
      isUploading: false,
      first: true,
      tip: {
        title: '...',
        body: '...'
      }
    }
  },
  computed: {
    atSpot () {
      return this.$store.state.atSpot
    },
    userHasPhotoAtSpot () {
      return this.$store.getters.userHasPhotoAtSpot
    },
    user () {
      return this.$store.state.user
    },
    uploading () {
      return this.$store.state.uploadingPhoto
    },
    uploadingPhotoProgress () {
      return parseInt(this.$store.state.uploadingPhotoProgress)
    },
    userOS () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/windows phone/i.test(userAgent)) {
        return 'windowsphone'
      }
      if (/android/i.test(userAgent)) {
        return 'android'
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios'
      }
      return false
    }
  },
  methods: {
    openInGoogle () {
      if (window.ga) {
        window.ga('send', 'event', 'Open app', 'open', 'Open Lightroom Android')
      }
    },
    openInIos () {
      if (window.ga) {
        window.ga('send', 'event', 'Open app', 'open', 'Open Lightroom iOS')
      }
      var windowExt = window.open('http://exhibitionstockholm.se/deep.html')
      window.setTimeout(function () {
        windowExt.close()
      }, 2000)
    },
    saving () {
      this.isSaving = true
    },
    close () {
      this.$store.commit('showingPhotoUpload', false)
    },
    selectFile (e) {
      this.isSaving = true
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.isSaving = false
        return
      }
      this.createImageAndThumbnail(files[0])
    },
    randomPhotoTip () {
      let photoTips = [
        {
          title: 'Vibrance (Lyster)',
          body: 'Används för att antingen ge lite extra ”stuns” till eller tona ner färgerna i en bild.'
        },
        {
          title: 'Kontrast',
          body: 'Används för att justera ”avståndet” mellan en bilds ljusa och mörka delar. Ju starkare kontrast du ställer in, desto ljusare blir de ljusa delarna och desto mörkare de mörka. Genom att justera kontrasten och på så sätt förstärka färgskillnaderna går det att öka ”djupet” i bilden.'
        },
        {
          title: 'Exposure (Intensitet – Ljusstyrka)',
          body: 'Används för att göra alla färger i en bild antingen ljusare eller mörkare. Fungerar bra som komplement till kontrast. '
        },
        {
          title: 'Crop (Beskärning)',
          body: 'Används för att beskära en bild.'
        },
        {
          title: 'Saturation',
          body: 'Används för att göra färger i en bild mer eller mindre intensiva.'
        },
        {
          title: 'Clarity',
          body: 'Används för åstadkomma ett större djup, eller mer av en 3D-känsla, i en bild.'
        },
        {
          title: 'Whites & Highlights',
          body: 'När du justerar ”Whites” förstärks eller försvagas de vitaste och ljusaste pixlarna i en bild. Med ”Highlights” justeras endast de ljusa pixlar som inte är vita.'
        },
        {
          title: 'Black & Shadows',
          body: 'När du justerar ”Black” förstärks eller försvagas de svartaste och mörkaste pixlarna i bilden. Med ”Shadows” justeras endast de mörka pixlar som inte är svarta. Exempelvis kan du tona skuggorna i en bild'
        },
        {
          title: 'RAW-format',
          body: 'När du fotar i RAW-format sparas all så kallad rådata i bilden. En stor fördel med att spara datan är att du kan redigera bilden utan att den förlorar i kvalitet.'
        },
        {
          title: 'Tint',
          body: 'Används för att styra färgtonen i bilden.'
        },
        {
          title: 'Dehaze',
          body: 'Används för att ta bort eller öka ”dimmighet” i din bild. Dehaze är ett bra verktyg för att göra en bild mer skarp.'
        },
        {
          title: 'Shutterspeed (Slutartid)',
          body: 'Används för att reglera andelen ljus som kameran tar in. Exempel: Om du vill ta en bild på något i rörelse och ställer in kort slutartid kommer objektet upplevas som att det är ”fryst” i rörelsen. Fotar du samma objekt i rörelse med lång slutartid kommer hela rörelsen synas och objektet bli suddigt.'
        },
        {
          title: 'Rengör linsen',
          body: 'Mobilbilder kan ofta få ett betydligt lyft av något så enkelt som en ren kameralins. Se till att regelbundet rengöra den med en liten putsduk.'
        },
        {
          title: 'Kom igång med Lightroom Mobile',
          body: '<a href="https://helpx.adobe.com/lightroom/how-to/lightroom-mobile.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
        },
        {
          title: 'Så fotar du bäst med Lightroom Mobile',
          body: '<a href="https://helpx.adobe.com/lightroom/how-to/camera-effects-lightroom-mobile.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
        },
        {
          title: 'Så fotar du i raw i Lightroom Mobile',
          body: '<a href="https://helpx.adobe.com/lightroom/how-to/raw-file-mobile-photo-editor-app.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
        },
        {
          title: 'Så redigerar du bilder i Lightroom Mobile',
          body: '<a href="https://helpx.adobe.com/lightroom/how-to/lightroom-mobile-adjustments.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
        },
        {
          title: 'Lär dig justera färgerna korrekt i Lightroom Mobile',
          body: '<a href="https://helpx.adobe.com/lightroom/how-to/color-adjustment.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
        },
        {
          title: 'Återskapa samma redigering i Lightroom Mobile',
          body: '<a href="https://helpx.adobe.com/lightroom/how-to/edit-photos-lightroom-mobile-photoshop-fix.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
        }
      ]
      let randNr = Math.floor(Math.random() * (photoTips.length))
      return photoTips[randNr]
    },
    createImageAndThumbnail (file) {
      let reader = new FileReader()
      let canvas = document.getElementById('thumb-canvas')
      let ctx = canvas.getContext('2d')
      reader.onload = (e) => {
        document.getElementById('preview-image').style.backgroundImage = 'url(' + e.target.result + ')'
        let thumb = new Image()
        thumb.onload = () => {
          this.view = 'confirm'
          canvas.width = 600
          canvas.height = 600 * thumb.height / thumb.width
          if (thumb.height > thumb.width) {
            canvas.className += ' portrait'
          }
          ctx.drawImage(thumb, 0, 0, 600, 600 * thumb.height / thumb.width)
          let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
          if (iOS) {
            this.getOrientation(file, (result) => {
              this.drawRotated(result, ctx, canvas, thumb)
            })
          }
        }
        thumb.src = e.target.result
      }
      reader.readAsDataURL(file)
    },
    drawRotated (degreeNr, ctx, canvas, image) {
      var degree = 0
      switch (degreeNr) {
        case 1:
          degree = 0
          break
        case 2:
          degree = 0
          break
        case 3:
          degree = 180
          break
        case 4:
          degree = 180
          break
        case 5:
          degree = 90
          canvas.height = 600 * image.width / image.height
          break
        case 6:
          degree = 90
          canvas.height = 600 * image.width / image.height
          break
        case 7:
          degree = 270
          canvas.height = 600 * image.width / image.height
          break
        case 8:
          degree = 270
          canvas.height = 600 * image.width / image.height
          break
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.setTransform(1, 0, 0, 1, canvas.width / 2, canvas.height / 2)
      ctx.rotate(degree * Math.PI / 180)
      let imageW = 600
      let imageH = 600 * image.height / image.width
      ctx.drawImage(image, -imageW / 2, -imageH / 2, imageW, imageH)
      //  ctx.setTransform(1, 0, 0, 1, 0, 0)
      /*
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.save()
      if (degree === 90 || degree === 270) {
        ctx.translate(canvas.height / 2, canvas.width / 2)
      } else {
        ctx.translate(image.width / 2, canvas.height / 2)
      }
      ctx.rotate(degree * Math.PI / 180)
      ctx.drawImage(image, -canvas.width / 2, -canvas.height / 2, 600, 600 * image.height / image.width)
      ctx.restore()
      */
    },
    redo () {
      this.isSaving = false
      this.view = 'upload'
      document.getElementById('fileupload-input').value = ''
      document.getElementById('preview-image').style.backgroundImage = 'none'
    },
    getOrientation (file, callback) {
      var reader = new FileReader()
      reader.onload = function (e) {
        var view = new DataView(e.target.result)
        if (view.getUint16(0, false) !== 0xFFD8) return callback(-2)
        var length = view.byteLength
        var offset = 2
        while (offset < length) {
          var marker = view.getUint16(offset, false)
          offset += 2
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) return callback(-1)
            var little = view.getUint16(offset += 6, false) === 0x4949
            offset += view.getUint32(offset + 4, little)
            var tags = view.getUint16(offset, little)
            offset += 2
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) === 0x0112) {
                return callback(view.getUint16(offset + (i * 12) + 8, little))
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break
          } else {
            offset += view.getUint16(offset, false)
          }
        }
        return callback(-1)
      }
      reader.readAsArrayBuffer(file)
    },
    uploadImage () {
      this.isUploading = true
      let files = document.getElementById('fileupload-input').files
      if (!files.length) { return }
      let fileName = this.makeImageId(32)
      let thumbCanvas = document.getElementById('thumb-canvas')
      let thumb = thumbCanvas.toDataURL('image/jpeg', 0.9)
      let thumbFile = this.dataURItoBlob(thumb)
      //  console.log(fileName)
      //  console.log('thumb ==> ', thumbFile)
      //  console.log('file ==>', files[0])
      //  make thumbnail file
      this.$store.dispatch('uploadPhoto', {file: files[0], thumb: thumbFile, fileName: fileName, isFirst: this.first})
    },
    makeImageId (size) {
      let text = ''
      let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      for (var i = 0; i < size; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      return text
    },
    dataURItoBlob (dataURI) {
      let byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = window.atob(dataURI.split(',')[1])
      } else {
        byteString = unescape(dataURI.split(',')[1])
      }
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      let ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    }
  },
  mounted () {
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Photo Upload')
    }
    //  document.getElementById('photoUpload').
    if (this.userHasPhotoAtSpot) {
      this.first = false
      this.$store.commit('interupt', 'Du håller på att byta ut ditt foto på ' + this.atSpot[0] + '<h6>Du får bara tävla med en bild i taget på varje fotoplats. Om du byter ut din nuvarande bild kommer poängen du fått för bilden att försvinna. Om du är säker på att du vill fortsätta, tryck på Ladda upp foto.')
    }
    this.tip = this.randomPhotoTip()
  },
  beforeDestroy () {
    this.view = 'upload'
  },
  components: { }
}
</script>

<style scoped>
.body-white {
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  box-sizing: border-box;
}
#photoUpload {
	position: relative;
  min-height:100vh;
	top: 0px;
	left: 0px;
  background-color: #fff;
	z-index: 99999;
  overflow-x: hidden;
}

#thumb-canvas {
  /*
  position: absolute;
  left: -2000px; */
  width: 100%;
  max-width: 600px;
  margin-top: 80px;
  display: inline-block;
  background-color: #fff;
}
.portrait {
  width: auto !important;
  max-height: 260px !important;
}
.upload-file-label {

}
.profile {

}
#preview-image {
  width: 100%;
  max-width: 600px;
  height: 170px;
  margin-top: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  display: inline-block;
  display: none;
}
.upload-icon {
  margin-top: 35px;
  margin-bottom: 30px;
  margin-left: -30px;
  width: 100%;
  height: 80px;
  background-image: url('./../assets/photo_shadow.svg');
  background-position: center center;
  background-size: auto 76px;
  background-repeat: no-repeat;
}
label.upload-file-label span {
  cursor: pointer;
}
label.upload-file-label input[type="file"] {
    position: fixed;
    top: -1500px;
}
</style>



// WEBPACK FOOTER //
// PhotoUpload.vue?78795bec